<header
  class="sticky-top shadow-sm"
>
  @if (isStaging) {
    <div class="env-banner">⚠️ STAGING ENVIRONMENT - FOR TESTING ONLY</div>
  }
<nav
  class="navbar navbar-expand-md navbar-dark bg-brand shadow px-5"
>
  <div class="container-fluid">
    <!-- Brand -->
    <a class="navbar-brand d-flex align-items-center gap-2" routerLink="/">
      <img
        ngSrc="/logo.png"
        alt="logo"
        width="864"
        height="120"
        class="d-inline-block align-text-top"
        style="height: 32px; width: auto"
      />
    </a>

    <!-- Toggler -->
    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#mainNavbar"
      aria-controls="mainNavbar"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <!-- Collapsible -->
    <div class="collapse navbar-collapse" id="mainNavbar">
      <!-- Left: links -->
      <ul class="navbar-nav me-auto mb-2 mb-md-0">
        <li class="nav-item">
          <a
            class="nav-link tabs-color"
            routerLink="/"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            >Home</a
          >
        </li>

        <li class="nav-item">
          <a
            class="nav-link tabs-color"
            routerLink="/banners"
            routerLinkActive="active"
            >Banners</a
          >
        </li>

        <li class="nav-item">
          <a
            class="nav-link tabs-color"
            routerLink="/wins"
            routerLinkActive="active"
            >Wins</a
          >
        </li>

        <li class="nav-item">
          <a
            class="nav-link tabs-color"
            routerLink="/testimonials"
            routerLinkActive="active"
            >Testimonials</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link tabs-color"
            routerLink="/announcements"
            routerLinkActive="active"
            >Announcements</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link tabs-color"
            routerLink="/users"
            routerLinkActive="active"
            >Users</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link tabs-color"
            routerLink="/subscriptions"
            routerLinkActive="active"
          >Subscriptions</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link tabs-color"
            routerLink="/products"
            routerLinkActive="active"
          >Products</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link tabs-color"
            routerLink="/viper/recap"
            routerLinkActive="active"
            >VIPER Recap</a
          >
        </li>
      </ul>

      <!-- Right: User menu -->
      <div class="d-flex align-items-center">
        <button class="btn btn-outline-light btn-sm" (click)="logout()">
          <i class="pi pi-sign-out me-2"></i>
          Logout
        </button>
      </div>
    </div>
  </div>
</nav>
</header>
